export default __webpack_public_path__ + "static/media/collapse-on.30620a77.svg";